<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M66.4255 38L61.5 18" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M38.5 18.5L34.0709 38" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 38H32V42.5C32 47.1944 28.1944 51 23.5 51V51C18.8056 51 15 47.1944 15 42.5V38Z" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<path d="M32 38H50V42C50 46.9706 45.9706 51 41 51V51C36.0294 51 32 46.9706 32 42V38Z" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<path d="M50 38H67V42.5C67 47.1944 63.1944 51 58.5 51V51C53.8056 51 50 47.1944 50 42.5V38Z" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<path d="M67 38H85V42C85 46.9706 80.9706 51 76 51V51C71.0294 51 67 46.9706 67 42V38Z" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<path d="M50 18.5V39.5" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 49V82H81V49" stroke="black" stroke-width="4"/>
<rect x="40" y="62" width="20" height="20" stroke="black" stroke-width="4"/>
<path d="M15 38L25.4317 18H74.0791L85 38" stroke="black" stroke-width="4" stroke-linejoin="round"/>
</svg>

</template>
